<template lang="pug">
.container-fluid
	.card
		.card-header.bg-info.text-white
			span.fa.fa-search.mr-2
			| Buscador
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
					.form-group
						label Texto
						input.form-control(v-model="filtro.cadena", placeholder="Busca por cadena de texto", @keypress.enter="buscar")
				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
					.form-group
						label Mes caduca
						.input-group
							datepicker(
								minimum-view="month"
								:monday-first="true"
								v-model="filtro.FechaLimite"
								input-class="form-control"
								:language="$dateLang"
								format="MMMM, yyyy"
								@input="buscar"
							)
							.input-group-append
								button.btn.btn-danger(@click="borrarMes")
									span.fa.fa-trash
				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
					.form-group
						label Estado
						br
						.btn-group
							button.btn(:class="(filtro.caducada === false) ? 'btn-primary' : ''", @click="setEstado(false)") Activas
							button.btn(:class="(filtro.caducada === null) ? 'btn-primary' : ''", @click="setEstado(null)") Todas
							button.btn(:class="(filtro.caducada === true) ? 'btn-primary' : ''", @click="setEstado(true)") Caducadas
		.card-footer
			button.btn.btn-sm.btn-primary.mr-2(@click="buscar")
				span.fa.fa-search.mr-2
				| Buscar

			button.btn.btn-sm.btn-warning(@click="editando = 'nuevo'")
				span.fa.fa-edit.mr-2
				| Nuevo elemento

	.card.mt-3
		.card-header.bg-dark.text-white
			span.fa.fa-list.mr-2
			| Resultados
		table.table.table-striped.m-0
			thead
				tr
					th Fecha límite
					th Título
					th Usuario
					th Noticias vinculadas
					th
			tbody
				tr(
					v-for="res in resultados"
					:key="res.AgendaID"
				)
					td
						span(v-if="res.FechaLimite") {{res.FechaLimite * 1 | moment('DD-MM-YYYY')}}
						span(v-else) Sin fecha
					td {{res.Titulo}}
					td {{res.UsuarioNombre}}
					td(v-if="res.NumeroNoticias > 0", @click="verNoticias(res)", style="cursor: pointer;") {{res.NumeroNoticias}}
					td(v-else) 0
					td
						button.m-1.btn.btn-sm.btn-warning(@click="editando = res.AgendaID")
							span.fa.fa-edit

						button.m-1.btn.btn-sm.btn-danger(@click="eliminar(res)")
							span.fa.fa-trash

	Editor(v-if="editando", :AgendaID="editando", @cerrar="editando = null", @actualizar="buscar")
	ListadoNoticias(v-if="verNoticiasAgenda", :agenda="verNoticiasAgenda", @cerrar="verNoticiasAgenda = null")
</template>

<script>
import Editor from './editor'
import ListadoNoticias from './listadoNoticias'
export default {
	components: {
		Editor,
		ListadoNoticias
	},
	data () {
		return {
			filtro: {
				cadena: '',
				caducada: false,
				FechaLimite: new Date()
			},
			editando: null,
			resultados: [],
			verNoticiasAgenda: null
		}
	},
	created () {
		this.buscar()
	},
	methods: {
		verNoticias (agenda) {
			this.verNoticiasAgenda = agenda
		},
		setEstado (estado) {
			this.filtro.caducada = estado
			this.buscar()
		},
		borrarMes () {
			this.filtro.FechaLimite = null
			this.buscar()
		},
		buscar () {
			const form = JSON.parse(JSON.stringify(this.filtro))
			form.FechaLimite = (this.filtro.FechaLimite) ? Math.floor(this.filtro.FechaLimite.getTime() / 1000) : null
			this.$http.post('redaccion/php/api/agenda/buscar.php', form)
				.then(res => {
					this.resultados = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		eliminar (agenda) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar',
				mensaje: `¿Quieres eliminar este elemento de la agenda?

				<b>Atención</b> Todas las noticias que estén relacionadas dejarán de estarlo`,
				callback: acepta => {
					if (acepta) {
						this.$http.post('redaccion/php/api/agenda/delAgenda.php', {AgendaID: agenda.AgendaID})
							.then(() => {
								this.buscar()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/agenda/agenda.vue